<template>
  <pre v-html="json" />
</template>

<script>
import _ from 'lodash'

import { subscription_mixin } from '@/components/mixin.js'
import { json_syntax_highlight } from '@/utils.js'
import { projects_pipe_object_rawget } from '@/api/subscriptions.js'

// *****************************************************************************

export default {
  name: 'JsonViewer',
  components: {},
  mixins: [subscription_mixin],
  props: ['project_id', 'poid'],
  data() {
    return {
      json: '',
    }
  },
  watch: {
    project_id(nv) {
      this.get_json_value()
    },
    poid(nv) {
      this.get_json_value()
    },
  },
  mounted() {
    this.get_json_value()
  },
  methods: {
    async get_json_value() {
      let json = (await projects_pipe_object_rawget(this.project_id, this.poid))
        .pipe_object
      // console.log(json)
      this.json = json_syntax_highlight(JSON.stringify(json, null, 2))
    },
  },
}
</script>
